import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { TwoColumn } from '@/components/frontend/atoms/layout/TwoColumn'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Text } from '@/components/frontend/atoms/typography/Text'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { FeatureItem } from '@/components/frontend/molecules/FeatureItem'
import type { IconName } from '@/components/frontend/atoms/content/IconBox'
import { useTranslation } from '@/hooks/useTranslation'

const PARAGRAPHS = ['p1', 'p2'] as const

const PRINCIPLES: { key: string; icon: IconName }[] = [
  { key: 'direct', icon: 'user-check' },
  { key: 'price', icon: 'gauge' },
  { key: 'ownership', icon: 'key' },
  { key: 'privacy', icon: 'shield' },
]

export const AboutSection: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Section padding="lg" background="alt" id="about">
      <Container>
        <TwoColumn gap="12" alignItems="start">
          <Stack gap="6">
            <SectionIntro label={t('about.label')} title={t('about.heading')} />
            <Stack gap="4">
              {PARAGRAPHS.map((key) => <Text key={key} tone="secondary">{t(`about.${key}`)}</Text>)}
            </Stack>
          </Stack>
          <ResponsiveGrid cols="2" gap="8">
            {PRINCIPLES.map(({ key, icon }) => (
              <FeatureItem
                key={key}
                icon={icon}
                title={t(`about.${key}_title`)}
                description={t(`about.${key}_desc`)}
              />
            ))}
          </ResponsiveGrid>
        </TwoColumn>
      </Container>
    </Section>
  )
}
